import React from "react";

import TeamType from "./TeamType";
import { Divider } from "sulu-admin-bundle/components";
import styles from "./team-authorization.module.scss";
import { generateKey } from "../../utils/generateKey";

const TeamGroup = ({ category, data }) => {
    return (
        <div className={styles["team-group"]}>
            <Divider className={styles["team-group__divider"]}>
                {category}
            </Divider>

            <div className={styles["team-group__items"]}>
                {Object.keys(data).map((gender) => {
                    return Object.keys(data[gender]).map((team, index) => {
                        const key = generateKey(index);
                        return (
                            <div
                                className={styles["team-group__item"]}
                                key={key}
                            >
                                <Divider>{team}</Divider>
                                <TeamType
                                    teamData={data[gender][team]}
                                    team={team}
                                />
                            </div>
                        );
                    });
                })}
            </div>
        </div>
    );
};

export default TeamGroup;
